/**
 * Usage-reporting hooks: the token/spend summary for the Usage dashboard.
 */

import {
  CURRENT_MONTH_USAGE_WINDOW,
  hubQueryKeys,
  type UsageSummaryPayload,
} from "@lifter/hub-ui/browser-shared";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { type AgentQueryOptions, useHubApi } from "./context";

export function useUsageSummaryQuery(range: UsageSummaryPayload, options: AgentQueryOptions = {}) {
  const api = useHubApi();
  return useQuery({
    queryKey: hubQueryKeys.usageSummary(range),
    queryFn: () => api.usage.summary(range),
    placeholderData: keepPreviousData,
    enabled: options.enabled ?? true,
  });
}

export { CURRENT_MONTH_USAGE_WINDOW };
